import React, {useState, useEffect} from 'react';
import {Link} from "react-router-dom";

import CountryFlagAndName from '../../components/countryFlagAndName.js'
import DomainTable from '../../components/domainTable.js'
import GeoDistribution from '../../components/geoDistribution.js'
import TechnologySmallIcon from '../../components/technologySmallIcon.js'

import imageOnError from '../../helpers/imgOnError.js';
import TechnologyMarketShare from '../../components/technologyChart.js'
import DistributionByPopularityChart from '../../components/technologyDistributionChart.js'
import useGoogleCharts from '../../components/useGoogleCharts.js';
import {_getCoutryGoogleChartName} from '../../helpers/helpers.js'
import CountriesLeadList from '../../components/countriesLeadList.js'
import TLDLeadList from '../../components/tldLeadList.js'



import {
	_printNumber, 
	_printPercent, 
	_extractWebsiteFromURL,
	_isGoogleIcon,
	_getGoogleIcon,
    _countryNameFromCode
	} from '../../helpers/helpers'

import {ASNPageResult} from '../../../../server/routes/asn.js'

interface ComponentProps {
	props: ASNPageResult;
}

// interface LeadListProps {
// 	props: ASNPageResult;
// 	title: string;
// 	count: string;
// }

export default function ASNID({server, pageData}: {server: string, pageData:unknown}) {

	const typedPageData = pageData as ASNPageResult;
	let [data, setData] = useState(typedPageData);

	return (
		<>
			<section className="section section-sm">
				<div className="container">
					<div className="row row-50">
						<div className="col-md-8 col-lg-8 col-xl-8">
							<TechnologyLeftPanel props={data}/>
						</div>
						{
						<div className="col-md-4 col-lg-4 col-xl-4">
							<TechnologyRightPanel props={data} />
						</div>
						}						
					</div>
				</div>
			</section>
		</>
	)
};

function NoDomainTechnology({props}: ComponentProps) { 

	return (
		<div className="row row-50">
			<div className="col-12">
                {
				<p>We did not find any websites that are hosted on AS{props.ASN} </p>
                }
			</div>
		</div>
	)
}

function TechnologyLeftPanel({props}: ComponentProps) {
	return (
		<>
			<h2 style={{wordWrap: 'break-word'}}>{props.PageTitle}</h2>
            Autonomous System Number {props.ASN}
			<hr/>
			{
				!props.DomainCount && 
					<NoDomainTechnology props={props}/>
			}
			{
				props.DomainCount != 0 &&
					<HasDomainTechnology props={props}/>
			}
		</>
	)
}

function TechnologyAvailableReports({props}: ComponentProps) {
    if (!props || !props.DomainCount) return null;

	return (
		<>
			<article className="box-bordered">
				<h4>Available Reports</h4>
				<br/>
				<div>
					<ul>
						<li>
							<Link 
								to={`/asn/${props.ASN}/websites`}
								className="link-hover" 
								title={`List of websites that are using AS${props.ASN} technology`}
							>
								Website List
							</Link>
						</li>       
						{
							props.TechnologyDevelopments &&                                       
							<li>
								<Link 
									to={`/asn/${props.ASN}/changes`} 
									className="link-hover" 
									title={`${props.ASN} adoption report`}
								>
									Usage Changes
								</Link>
							</li>
						}                                        
					</ul>      
				</div>
			</article>
			<br />
		</>
	)
}


function TechnologyRightPanel({props}: ComponentProps) {
	return (
		<div className="row row-35 row-lg-50">
			<div className="col-sm-12 col-lg-12">
				<TechnologyAvailableReports props={props}/>

			    <CountriesLeadList name={props.ASN} reporttype='none'  geoData={props.TechnologyGeoData} />
				<TLDLeadList  name={props.ASN} reporttype='none' tlds={props.TLDs}/>	
			</div>
		</div>
	)							
}

function HasDomainTechnology( {props}: ComponentProps ) {
	// Removed duplicate data (none graph)
 	//	<TechnologyDistribution props={props}/> 
	const google = useGoogleCharts();

	return (
		<>
			<TechnologyBrag props={props}/>

			{/*	<LeadListsTable props={props}/> */ }

			<TechnologyUsageStats props={props}/>
			{/*	<TechnologyDevelopments props={props}/>*/ }
			{/*	<DistributionByPopularityChart name={props.ASN} distribution={props.TechDistributionByPopularity} google={google}/>	*/ }	
			
			<TechnologyWebsites props={props}/>
			
			<GeoDistribution geoData={props.TechnologyGeoData} google={google}/>




		</>
	)
}

function TechnologyBrag({props}: ComponentProps) {
    let asn = props.ASN;
    let ASNName = props.ASNName;
	return (
		<>
			<br/>
			<p>
				We have discovered &nbsp;
				<Link 
					to={`/asn/${asn}/websites`}
					className="link-hover" 
					title={props.TechnologyDomains.Header.Subtitle} 
					rel="noopener nofollow" 
				> 
				<b>{_printNumber(props.DomainCount)} live websites</b>
				</Link>&nbsp;that are hosted on AS{asn}.
			</p>
			<p>			
		{/*
				<Link 
					to={`/create-report?asn=${asn}`}
					className="button button-secondary" 
					title={`Download list of websites hosted on AS${asn}`} 
					rel="noopener nofollow" 
				>
					Download Lead List
				</Link>
	*/}
			</p>
			<br />
		</>
	)
}

function TechnologyUsageStats({props}: ComponentProps) {

	return (
		<>
			<div className="row row-50">
			<div className="col-12">
				<h3 className="text-left">AS{props.ASN} usage statistics</h3>
				<table className="table-custom table-custom-striped table-custom-primary">
					<tbody>
						<tr>
							<td>Websites hosted on AS{props.ASN}</td>
							<td>
								<span className="icon text-primary">
									<Link 
										to={`/asn/${props.ASN}/websites`}
										className="link-hover" 
										title={`List of websites that are using AS${props.ASN} technology`} 
									>
										<b>{_printNumber(props.DomainCount)}</b> websites
									</Link>
								</span>
							</td>
						</tr>
						{/*
						UNUSED CODE!!! 
							props.TechnologyUsage != undefined && props.TechnologyUsage.LastMonthChange &&
								<tr>
									<td>Change from last month</td>
									<td>
										<span 
											className="icon  mdi mdi-arrow-down" 
											style={{color: 'red'}}
										>
											<b>
												{props.TechnologyUsage.LastMonthChange}%
											</b>
										</span>
									</td>
								</tr>
							*/
						}
						{
							props.TechnologyUsage != undefined && props.TechnologyUsage.MostPopularCountry &&
    							<tr>
                                    <td>
                                        Most popular in the country
                                    </td>
                                    <td>
                                        <b>
                                            <CountryFlagAndName countryCode={props.TechnologyUsage.MostPopularCountry.Country} />
                                        </b>
                                    </td>
                                </tr>  
                        }
                        {    
							props.TechnologyUsage != undefined && props.TechnologyGeoData.Countries && props.TechnologyUsage.DomainCount &&
                            <tr>
                                <td>
                                    AS{props.ASN} websites located in {_countryNameFromCode(props.TechnologyUsage.MostPopularCountry.Country)}
                                </td>
                                <td>
                                    <b>
                                        {_printPercent(props.TechnologyGeoData.Countries[0].DomainCount/props.TechnologyUsage.DomainCount)}%
                                    </b>
                                </td>
                            </tr>
						}

					</tbody>
				</table>
			</div>
		</div>
	</>
	)
}

function TechnologyDevelopments({props}: ComponentProps) {

	if (!props.TechnologyDevelopments) return null;

	return (
		<>
			<div className="row row-50">
				<div className="col-12">
					<h3 className="text-left">Technology adoption</h3>
					Recent changes in {props.ASN} usage.
					(See{' '}
						<Link 
							to={`/asn/${props.ASN}/changes`}
							className="link-hover" 
							title={`${props.ASN} adoption report`}
						>
							<b>{props.ASN} Usage Changes</b>
						</Link> 
					{' '}report)
					<br />
					<table className="table-custom table-custom-striped table-custom-primary">
						<tbody>
							{
								!!props.TechnologyDevelopments.AddedCount &&
								<tr>
									<td>
										Websites that added {props.ASN}
									</td>
									<td>
										<span 
											className="icon" 
											style={{color: 'green'}}
										>
											<b>
												+{_printNumber(props.TechnologyDevelopments.AddedCount)}
											</b>
										</span>
									</td>
								</tr>
							}
							{
								!!props.TechnologyDevelopments.DroppedCount &&
								<tr>
									<td>
										Websites that dropped {props.ASN}
									</td>
									<td>
										<span 
											className="icon" 
											style={{color: 'red'}}
										>
											<b>
												-{_printNumber(props.TechnologyDevelopments.DroppedCount)}
											</b>
										</span>
									</td>
								</tr>
							}
							{
								!!props.TechnologyDevelopments.ChangedVersionCount &&
								<tr>
									<td>Websites that changed version of {props.ASN}</td>
									<td>
										<span className="icon text-primary">
											<b>
												{_printNumber(props.TechnologyDevelopments.ChangedVersionCount)}
											</b>
										</span>
									</td>
								</tr>
							}
						</tbody>
					</table>
				</div>
			</div>		
		</>
	)
}
/*
function TechnologyDistribution({props}: ComponentProps) {

	return (
		<>
			<div className="row row-50">
				<div className="col-12">
					<h3 className="text-left">Distribution by websites popularity</h3>
					{props.ASN} detection in the top websites by popularity
					<table className="table-custom table-custom-striped table-custom-primary">
						<tbody>
							<tr>
								<td>Top 10k sites</td>
								<td><span className="icon text-primary">{_printNumber(props.TechDistributionByPopularity.Top10KUsage)} websites</span></td>
							</tr>
							<tr>
								<td>Top 100k sites</td>
								<td><span className="icon text-primary">{_printNumber(props.TechDistributionByPopularity.Top100KUsage)} websites</span></td>
							</tr>
							<tr>
								<td>Top 1m sites</td>
								<td><span className="icon text-primary">{_printNumber(props.TechDistributionByPopularity.Top1MUsage)} websites</span></td>
							</tr>
							<tr>
								<td>Top 10m sites</td>
								<td><span className="icon text-primary">{_printNumber(props.TechDistributionByPopularity.Top10MUsage)} websites</span></td>
							</tr>
						</tbody>
					</table>
				</div>
			</div>		
		</>		
	)
}
*/
function TechnologyWebsites({props}: ComponentProps) {

	return (
		<DomainTable domainList={props.TechnologyDomains}/>
	)
}




// function LeadListsTable({props}: ComponentProps) {

// 	if (!props) {
// 		return null
// 	}
// 	let name = props.ASN
// //	<div className="row row-50">
// //	<div className="col-12">
// //	</div>
// //	</div>

// 	return (
// 		<>	
// 			<br/>
// 			<hr></hr>		
// 			<br/>
// 			<h4>Lead Lists ideas</h4>
// 			Download targeted list of live websites based on changes in usage of {name} technology 
// 			{props.IsExclusiveCategory ? ` or its competitors from ${props.Category}` : ''}

// 			<table className="table-custom table-custom-striped table-custom-primary">
// 				<tbody>
// 					<LeadList props={props} title={`Websites that started using ${name} in the last 3 month`} count={`2,462`}/>
// 					<LeadList props={props} title={`Websites that stopped using ${name} in the last 3 month`} count={`1,345`}/>
// 					<LeadList props={props} title={`Websites that do not use ${props.Category} technologies but used it in the past.`} count={`462`}/>
// 					<LeadList props={props} title={`Websites that started using competing ${props.Category} technology 9-12 month ago`} count={`562`}/>
// 					<LeadList props={props} title={`Websites that started using ${name} 9-12 month ago`} count={`354`}/>
// 					<LeadList props={props} title={`Websites that switched to ${name} from competing ${props.Category} technology`} count={`7,462`}/>
// 					<LeadList props={props} title={`Websites that switched from ${name} to competing ${props.Category} technology `} count={`22,462`}/>
// 				</tbody>
// 			</table>

// 		</>
// 	)
// }

// function LeadList({props,title, count}: LeadListProps) {

// 	if (!title || !count) {
// 		return null
// 	}
// 	return (
// 		<>	
// 			<tr>
// 				<td>{title}&nbsp;</td>
// 				<td align="right">
// 					<Link 
// 						className="link-hover word-break" 
// 						title={`Download Lead List`}									
// 						to = {`/create-report?asn=${props.ASN}`}
// 					><b>{count}</b> websites 
// 					</Link>						
// 				</td>
// 			</tr>
// 		</>
// 	)
// }